<template>
    <a
        class="c-button"
        :class="{
            'is-large': size === 'large',
            'is-middle': size === 'middle',
            'is-small': size === 'small',
            'is-mini': size === 'mini',
            'is-primary': type === 'primary',
            'is-ghost': type === 'ghost',
            'is-transparent-dark': type === 'transparent-dark',
            'has-adaptation': adaptation === true,
        }"
        ><span class="button-text"><slot></slot></span
    ></a>
</template>

<script>
export default {
    name: "Button",
    props: {
        size: { type: String },
        type: { type: String },
        adaptation: { type: Boolean },
    },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    padding: 0 24px;
    border-radius: 6px;
    background: #e2e2e2;
    position: relative;
    overflow: hidden;
    &.is-xlarge {
        min-width: 248px;
        min-height: 64px;
        .button-text {
            font-size: 28px;
        }
    }
    &.is-large {
        min-width: 240px;
        min-height: 60px;
        .button-text {
            font-size: 26px;
        }
    }
    &.is-middle {
        min-height: 40px;
        padding: 0 24px;
        border-radius: 6px;
        .button-text {
            font-size: 16px;
        }
    }
    &.is-small {
        min-height: 32px;
        padding: 0 16px;
        border-radius: 4px;
        .button-text {
            font-size: 14px;
        }
        span {
            & + .gvfont {
                margin-left: 4px;
            }
        }
        .gvfont {
            & + span {
                margin-left: 4px;
            }
        }
    }
    &.is-mini {
        min-height: 24px;
        padding: 0 8px;
        border-radius: 2px;
        .button-text {
            font-size: 12px;
        }
    }
    &.is-primary {
        background-image: linear-gradient(to right, #4e8cff, #415cf9);
        &::after {
            content: "";
            display: inline-block;
            position: absolute;
            width: 0;
            height: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            border-radius: 8px;
            background-image: radial-gradient(rgba(65, 92, 249, 0.8), rgba(78, 140, 255, 0.4));
            z-index: 1;
            transition: ease-in-out 0.16s;
        }
        &:hover {
            &::after {
                width: 100%;
                height: 100%;
                transition: ease-in-out 0.08s;
            }
        }
        .button-text {
            color: #fff;
        }
    }
    &.is-ghost {
        border: 1px solid #fff;
        background: transparent;
        &:hover {
            opacity: 0.64;
        }
        .button-text {
            color: #fff;
        }
    }
    &.is-transparent-dark {
        background: rgba(0, 0, 0, 0.16);
        .button-text {
            color: #fff;
        }
    }
    .button-text {
        display: inline-flex;
        align-items: center;
        font-size: 16px;
        line-height: 1;
        color: rgb(46, 46, 46);
        white-space: nowrap;
        position: relative;
        z-index: 3;
    }
}
@media only screen and (max-width: 1200px) {
    .c-button {
        &.has-adaptation {
            &.is-xlarge {
                min-width: 240px;
                min-height: 60px;
                .button-text {
                    font-size: 26px;
                }
            }
            &.is-large {
                min-height: 40px;
                padding: 0 24px;
                border-radius: 6px;
                .button-text {
                    font-size: 16px;
                }
            }
            &.is-middle {
                min-height: 32px;
                padding: 0 16px;
                border-radius: 4px;
                .button-text {
                    font-size: 14px;
                }
            }
            &.is-small {
                min-height: 24px;
                padding: 0 8px;
                border-radius: 2px;
                .button-text {
                    font-size: 12px;
                }
            }
            &.is-mini {
                min-height: 16px;
                padding: 0 4px;
            }
        }
    }
}
</style>
